const assetPrefix =
  process.env.ASSET_PREFIX || process.env.NEXT_PUBLIC_ASSET_PREFIX;

export const addAssetPrefix = (assetSrc: string): string => {
  if (assetPrefix) return `${assetPrefix}/${assetSrc}`;

  return assetSrc;
};
